<script setup>

import Select from "primevue/select";
import ToggleSwitch from "primevue/toggleswitch";
import { trans } from 'laravel-vue-i18n';

const form = defineModel()

const reservationPageSettings = [
    { value: 'off',            label: trans('settings.policy_off') },
    { value: '1 day',          label: trans('settings.policy_1_day') },
    { value: '2 days',         label: trans('settings.policy_2_days') },
    { value: '3 days',         label: trans('settings.policy_3_days') },
    { value: '4 days',         label: trans('settings.policy_4_days') },
    { value: '5 days',         label: trans('settings.policy_5_days') },
    { value: '6 days',         label: trans('settings.policy_6_days') },
    { value: '1 week',         label: trans('settings.policy_1_week') },
    { value: '2 weeks',        label: trans('settings.policy_2_weeks') },
    { value: '1 month',        label: trans('settings.policy_1_month') },
    { value: 'no restriction', label: trans('settings.policy_no_restriction') },
];
</script>

<template>
    <div class="setting-item mb-6">
        <label class="block text-sm font-medium mb-2">{{ $t('settings.change_label') }}</label>
        <Select
            v-model="form.reservation_change_settings"
            :options="reservationPageSettings"
            optionLabel="label"
            option-value="value"
            :placeholder="$t('settings.select_placeholder')"
            class="w-full"
        />
    </div>

    <div class="setting-item mb-6">
        <label class="block text-sm font-medium mb-2">{{ $t('settings.cancel_label') }}</label>
        <Select
            v-model="form.reservation_cancel_settings"
            :options="reservationPageSettings"
            optionLabel="label"
            option-value="value"
            :placeholder="$t('settings.select_placeholder')"
            class="w-full"
        />
    </div>

    <div class="setting-item mb-6">
        <label class="block text-sm font-medium mb-2">{{ $t('settings.change_auto_approve_label') }}</label>
        <div class="flex items-center gap-4">
            <ToggleSwitch
                v-model="form.reservation_change_auto_approve"
                trueValue="Y"
                falseValue="N"
            />
            <span class="text-sm">
                {{ form.reservation_change_auto_approve === 'Y' ? $t('settings.approve_auto') : $t('settings.approve_wait') }}
            </span>
        </div>
    </div>

    <div class="setting-item">
        <label class="block text-sm font-medium mb-2">{{ $t('settings.cancel_auto_approve_label') }}</label>
        <div class="flex items-center gap-4">
            <ToggleSwitch
                v-model="form.reservation_cancel_auto_approve"
                trueValue="Y"
                falseValue="N"
            />
            <div class="text-sm">
                {{ form.reservation_cancel_auto_approve === 'Y' ? $t('settings.approve_auto') : $t('settings.approve_wait') }}
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
